import { createGlobalStyle } from 'styled-components';
import { colors } from './helpers';
// CSS
import 'sanitize.css';
import 'sanitize.css/forms.css';
import 'sanitize.css/typography.css';

const Globals = createGlobalStyle`

 a, a:hover, a:focus, a:active {
     text-decoration: none;
     color: inherit;
 }

.cursor-pointer {
  cursor: pointer;
  }

.primaryPeach {
  color: ${colors.primaryPeach};
  }
.defaultWhite {
  color: ${colors.defaultWhite};
}

.bold {
  font-weight: bold;
  }
`;

export default Globals;
